import { render, staticRenderFns } from "./pages2.vue?vue&type=template&id=22d14ac2&scoped=true&"
import script from "./pages2.vue?vue&type=script&lang=js&"
export * from "./pages2.vue?vue&type=script&lang=js&"
import style0 from "./pages2.vue?vue&type=style&index=0&id=22d14ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d14ac2",
  null
  
)

export default component.exports